(() => {
  const getItems = () => {
    // あなたのHTMLに合わせた最優先セレクタ
    const primary = document.querySelectorAll(
      ".col-sp-6.col-md-4.col-one_fifth"
    );
    if (primary.length) return Array.from(primary);

    // 予備（テーマ差分用）
    const fallback = document.querySelectorAll(".product-card");
    return Array.from(fallback).map(el => el.closest("li, .grid__item, div") || el);
  };

  const init = () => {
    // コレクション/検索/トップの一覧などでも動く可能性があるので、必要なら絞ってOK
    const items = getItems();
    if (!items.length) return;

    // 既にクラス付いてたら二重適用を避ける
    const targets = items.filter(el => !el.classList.contains("collection-reveal-item"));

    // スタガー（順番）設定
    const step = 70;   // ms
    const cap = 14;    // 最初の14個まで段差、以降は同じ
    targets.forEach((el, i) => {
      el.classList.add("collection-reveal-item");
      const delay = Math.min(i, cap) * step;
      el.style.setProperty("--reveal-delay", `${delay}ms`);
    });

    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -12% 0px", // 少し早めに出す
        threshold: 0.12
      }
    );

    targets.forEach(el => io.observe(el));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // 無限スクロール/フィルタで商品が差し替わる場合の保険
  const mo = new MutationObserver(() => {
    // 連続発火を抑える
    clearTimeout(window.__collectionRevealTimer);
    window.__collectionRevealTimer = setTimeout(() => init(), 120);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
